/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.accordion__item').forEach(item => {
      const titleEl = item.querySelector('.accordion__item__title__text');
      const container = item.querySelector('[data-collapsible-container]');
      const btn = item.querySelector('[data-collapsible-trigger]');

      if (titleEl && titleEl.textContent.trim() === 'Descripción' && container && btn) {
        btn.classList.add('is-open');
        container.style.maxHeight = container.scrollHeight + 'px';
        container.setAttribute('aria-expanded', 'true');
        item.classList.add('accordion__item--open');
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
